import { Avatar } from '~/components/Avatar';
import { cn } from '~/lib/cn';
import { TruncateWithTooltip } from '~/modules/settings/components/TruncateWithTooltip';

interface UserInfoProps extends React.HTMLAttributes<HTMLDivElement> {
  fullName: string;
}

export function UserInfo({ fullName, className, ...props }: UserInfoProps) {
  return (
    <div className={cn('flex max-w-full items-center', className)} {...props}>
      <Avatar name={fullName} className="mr-sm" variant="base" size="sm" />
      <TruncateWithTooltip className="inline-block">
        {fullName}
      </TruncateWithTooltip>
    </div>
  );
}

UserInfo.displayName = 'UserInfo';
